swellDef = {
    vipTiers: [{
        levelAmount: 'Spend: $0 - $500',
        level: 'Essential',
        multiplier: '1X',
        discount: ["<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>", '', '', '', '', '', '']
    }, {
        levelAmount: 'Spend: $500 - $799',
        level: 'Vintage',
        multiplier: '2X',
        discount: ["<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>", '', '']
    }, {
        levelAmount: 'Spend: $800+',
        level: 'Prime',
        multiplier: '3X',
        discount: ["<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>", "<i class='fa fa-circle' aria-hidden='true'></i>"]
    }],
    redemptionsExclusions: [{
        name: "TEST12345"
    }],
    referralShareLinks: [{
        class: "swell-share-referral-facebook",
        href: "javascript:void(0)",
        icon: "fa fa-facebook",
        text: "Share",
        /* img: "{{'swell-message-icon.png' | asset_img_url: 'master' }}" */
    },
    {
        class: "swell-share-referral-messenger",
        href: "javascript:void(0)",
        icon: "fa fa-commenting",
        text: "Message",
        /* img: "{{'swell-message-icon.png' | asset_img_url: 'master' }}" */
    },
    {
        class: "swell-share-referral-twitter",
        href: "javascript:void(0)",
        icon: "fa fa-twitter",
        text: "Tweet",
        /* img: "{{'swell-tweet-icon.png' | asset_img_url: 'master' }}" */
    },
    {
        class: "swell-share-referral-sms",
        href: "javascript:void(0)",
        icon: "fa fa-mobile",
        text: "SMS",
        /*  img: "{{'swell-sms-icon.png' | asset_img_url: 'master' }}" */
    }
    ],
    referralForms: {
        newUserForm: {
            inputType: "text",
            submitText: "NEXT",
            labelText: "",
            placeholder: "Enter your email to get started",
            formType: "new"
        },
        existingUserForm: {
            inputType: "text",
            submitText: "SEND",
            labelText: "",
            placeholder: "Your friends' emails (separated by commas)",
            formType: "existing"
        },
        externalContent: {
            referralEmailExists: "Enter your email",
            referralEmailExistsForm: {
                inputs: [{
                    type: "text"
                },
                {
                    name: "email"
                },
                {
                    placeholder: "Enter your email"
                }
                ]
            }
        }
    },
    redemptionsExclusions: [{}]
}